import { getSessionStorage, StorageKey } from '@utils/StorageUtils';
import { Country } from '@utils/pageConfig/Types';
import { Action, MarketPremiumRetailerClientTypes } from '@state/actions/Type';

export interface MarketPremiumRetailerClientState {
  clientId: number;
  countries: Country[];
  clientName?: string;
  pageViewing?: string;
}

const getInitialState = () => {
  const storeMarketPremiumRetailerClient = JSON.parse(
    getSessionStorage(StorageKey.MarketPremiumRetailerClient) as string,
  );

  if (storeMarketPremiumRetailerClient !== null) {
    return {
      clientId: storeMarketPremiumRetailerClient.clientId,
      countries: storeMarketPremiumRetailerClient.countries,
      clientName: storeMarketPremiumRetailerClient.clientName,
    };
  }

  return Object.freeze({
    clientId: -1, // -1 for default clientId
    countries: [
      {
        id: '',
        name: '',
        currency: '',
      },
    ],
  });
};

const MarketPremiumRetailerClientReducer = (
  state: MarketPremiumRetailerClientState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === MarketPremiumRetailerClientTypes.MarketPremiumRetailerClientUpdate) {
    return {
      ...state,
      clientId: action.payload.clientId,
      countries: action.payload.countries,
      clientName: action.payload.clientName,
    };
  }
  return state;
};

export default MarketPremiumRetailerClientReducer;
